export default __webpack_public_path__ + "static/media/p1-c3-s2.70935597.png";